<div fxLayout="column" fxLayoutGap="5px">
    <div fxFlex="1 1 auto" fxLayoutGap="5px">
        <p-calendar [(ngModel)]="operatingDate" [showIcon]="true"
            (onSelect)="onOperatingDateSelected($event)"></p-calendar>
        <button pButton pRipple type="button" class="p-button-raised dashboard-button" label="Sign Off"
            icon="pi pi-thumbs-up" (click)="showApproveDialog=true" [disabled]="!approveEnabled()">
        </button>
    </div>
    <p-table fxFlex="1 1 auto" [value]="eodSignOffs" [loading]="loading" [(selection)]="selectedEODSignOffs"
        dataKey="itemKey" [scrollable]="true" scrollHeight="flex" [style.height]="'85vh'">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5vw; text-align: 'center'">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 3vw; text-align: 'center'"> </th>
                <th style="width: 10vw; text-align: 'center'">Type</th>
                <th style="width: 10vw; text-align: 'center'">Name</th>
                <th style="width: 20vw; text-align: 'center'">Description</th>
                <th style="width: 18vw; text-align: 'center'">Action</th>
                <th style="width: 10vw; text-align: 'center'">Status</th>
                <th style="width: 8vw; text-align: 'center'">Signed Off By</th>
                <th style="width: 10vw; text-align: 'center'">Sign Off Time</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record>
            <tr>
                <td style="width: 5vw; text-align: 'center'">
                    <p-tableCheckbox [disabled]="record.status === 'SIGNED_OFF'" [value]="record"></p-tableCheckbox>
                </td>
                <td style="width: 3vw; text-align: 'center'">
                    <button *ngIf="record.signOffType === 'EOD_DATA_ACCURACY'" pButton pRipple icon="pi pi-book" class="p-button-rounded p-button-outlined p-button-info"></button>
                    <button *ngIf="record.signOffType === 'SOURCE_SYSTEM_READINESS'" pButton pRipple icon="pi pi-copy" class="p-button-rounded p-button-outlined p-button-info"></button>
                </td>
                <td style="width: 10vw; text-align: 'center'">                    
                    {{record.signOffType}}
                </td>
                <td style="width: 10vw; text-align: 'center'">{{record.identifier}}</td>
                <td style="width: 20vw; text-align: 'center'">{{record.description}}</td>
                <td *ngIf="record.status === 'PENDING' && record.signOffType === 'SOURCE_SYSTEM_READINESS'"
                    style="width: 18vw; text-align: 'center'">
                    <p-selectButton [options]="['NONE','RE_EXTRACT']" [(ngModel)]="record.actionToTake"
                        optionLabel="action">
                        <ng-template let-item>
                            {{item}}
                        </ng-template>
                    </p-selectButton>
                </td>
                <td *ngIf="record.status !== 'PENDING' && record.signOffType === 'SOURCE_SYSTEM_READINESS'"
                    style="width: 18vw; text-align: 'center'">
                    <span [class]="'status-badge status-' + record.actionToTake">{{record.actionToTake}}</span>
                </td>
                <td *ngIf="record.signOffType === 'EOD_DATA_ACCURACY'" style="width: 18vw; text-align: 'center'">
                    <span [class]="'status-badge status-' + record.actionToTake">N/A</span>
                </td>

                <td style="width: 10vw; text-align: 'center'">
                    <span [class]="'status-badge status-' + record.status">{{record.status}}</span>
                </td>
                <td style="width: 8vw; text-align: 'center'">{{record.signOffUser}}</td>
                <td style="width: 10vw; text-align: 'center'">{{record.signOffDatetime}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Sign Off" [(visible)]="showApproveDialog" [modal]="true" [style]="{width: '30vw'}">
    <ng-template pTemplate="body">
        <h3>Are you sure you wish to officially Sign Off on:</h3>
        <ul>
            <ng-container *ngFor="let eodSignOff of selectedEODSignOffs">
                <li *ngIf="eodSignOff.signOffType === 'SOURCE_SYSTEM_READINESS' && eodSignOff.actionToTake === 'NONE'">
                    {{eodSignOff.identifier}} data is correct AS IS</li>
                <li
                    *ngIf="eodSignOff.signOffType === 'SOURCE_SYSTEM_READINESS' && eodSignOff.actionToTake === 'RE_EXTRACT'">
                    {{eodSignOff.identifier}} data requires a re-extraction to replace previous data</li>
                <li *ngIf="eodSignOff.signOffType === 'EOD_DATA_ACCURACY'">All Liquitics Application Data is for
                    {{eodSignOff.batchIdentifier}} is validated and correct</li>
            </ng-container>
        </ul>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button (click)="showApproveDialog=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button (click)="onApproveConfirm()" label="Sign Off" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>